import React from 'react';
import {connect} from "react-redux";
import PublicLayout from "../Public";
import {Button, Col, Form, Input, Row,Typography} from "antd";
import language from "../../languages/language";
import LinkOutlined from "@ant-design/icons/lib/icons/LinkOutlined";
import LockOutlined from "@ant-design/icons/lib/icons/LockOutlined";
import UserOutlined from "@ant-design/icons/lib/icons/UserOutlined";
import TitleAndInfo from "../TitleAndInfo/TitleAndInfo";
import prepareDocs from "../../actions/prepareDocs";
import regenCodes from "../../actions/regenCodes";
import messageShow from "../../actions/messageShow";

class Codes extends React.Component
{
    state={resend:false,otpTimer:null}
    formRef = React.createRef();

    componentWillUnmount()
    {
        window.clearInterval(this.state.otpTimer);
    }

    componentDidMount()
    {
        this.createTimer();
    }

    createTimer=()=>
    {
        let otpTimer = setInterval( () => {
            if(!this.state.resend)
                this.setState({resend: true});
        }, 5000 );
        this.setState({otpTimer: otpTimer});
        this.setState({resend: true});
    };

    createUser=(formValues)=>
    {
        const newValues = {...formValues,...this.props.info};
        newValues.agree=true;
        this.props.prepareDocs(newValues);
    };

    regenCodes=()=>
    {
        window.clearInterval(this.state.otpTimer);
        this.formRef.current.resetFields();
        this.setState({resend:false},this.createTimer);
        this.props.regenCodes({certid:this.props.info.certid}).then(this.showMessage);
    };

    showMessage=()=>
    {
        this.props.messageShow({message: language[this.props.language].regenOK, type: 'success'});
    };

    handleClick=(e)=>
    {
        e.preventDefault();
        this.regenCodes();
    };

    render()
    {
        const span=18;
        return <PublicLayout title={'logo'} size={'large'}>
            <TitleAndInfo info={language[this.props.language].codesLabel}/>
            <Form ref={this.formRef} onFinish={this.createUser} className={'regularForm'}
                  initialValues={{userName:this.props.info.userName,referenceNumber:this.props.info.referenceNumber}}>
                <Row justify={'center'}>
                    <Col span={span}>
                        <Typography style={{fontSize:'15px',fontWeight:'bold',textAlign:'center'}}>{language[this.props.language].inputCodeLabel}</Typography>
                    </Col>
                </Row>
                <Row style={{marginBottom: 10}}/>
                {this.props.info.referenceNumber?'':<Row justify={'center'}>
                    <Col span={span}>
                        <Form.Item name="referenceNumber"
                                   rules={[{required: true,
                                       message: language[this.props.language].requiredError }]}>
                            <Input autoComplete={'off'} placeholder={language[this.props.language].refLabel}
                                   size={'large'} className={'mb-10'}
                                   prefix={<LinkOutlined style={{color: 'rgba(0,0,0,.25)'}} />}/>
                        </Form.Item>
                    </Col>
                </Row>}
                <Row justify={'center'}>
                    <Col span={span}>
                        <Form.Item name="authCode"
                                   rules={[{required: true,
                                       message: language[this.props.language].requiredError }]}>
                            <Input autoComplete={'off'} placeholder={language[this.props.language].authCodeLabel}
                                   size={'large'} className={'mb-10'}
                                   prefix={<LinkOutlined style={{color: 'rgba(0,0,0,.25)'}} />}/>
                        </Form.Item>
                    </Col>
                </Row>
                <Row justify={'center'}>
                    <Col span={span}>
                        <Form.Item name="userName"
                                   rules={[{required: true,
                                       message: language[this.props.language].requiredError }]}>
                            <Input autoComplete={'username'} readOnly={true} placeholder={language[this.props.language].userLabel}
                                   size={'large'} className={'mb-10'}
                                   prefix={<UserOutlined style={{color: 'rgba(0,0,0,.25)'}} />}/>
                        </Form.Item>
                    </Col>
                </Row>
                <Row justify={'center'}>
                    <Col span={span}>
                        <Form.Item name="password"
                                   rules={[{required: true,
                                       message: language[this.props.language].requiredError }]}>
                            <Input.Password autoComplete="new-password" placeholder={language[this.props.language].passwordLabel}
                                   size={'large'} className={'mb-10'}
                                            prefix={<LockOutlined style={{color: 'rgba(0,0,0,.25)'}}/>}/>
                        </Form.Item>
                    </Col>
                </Row>
                <Row justify={'center'}>
                    <Col span={span}>
                        <Form.Item name="confirm"
                                   rules={[{required: true,
                                       message: language[this.props.language].requiredError }]}>
                            <Input.Password autoComplete="new-password" placeholder={language[this.props.language].confirmLabel}
                                   size={'large'} className={'mb-10'}
                                            prefix={<LockOutlined style={{color: 'rgba(0,0,0,.25)'}}/>}/>
                        </Form.Item>
                    </Col>
                </Row>
                <Row justify={'center'}>
                    <Col span={span}>
                        <Form.Item className={'text-center'}>
                            <Button type="primary light-blue rounded" htmlType="submit">
                                {language[this.props.language].nextLabel}
                            </Button>
                        </Form.Item>
                    </Col>
                </Row>
                {this.state.resend?<Row justify={'center'}>
                    <Col onClick={this.handleClick} style={{textAlign:'center'}} span={span}>
                        <Typography.Link className='color-primary' style={{textDecoration:'underline', fontSize:'15px'
                                         ,fontWeight:'bold'}}
                                         href="#" target="_self">
                            {language[this.props.language].resendLabel}</Typography.Link>
                    </Col>
                </Row>:''}

            </Form>
        </PublicLayout>;
    }
}
function mapStateToProps(state) {
    return {
        language: state.auth.language,
        info:state.info
    }
}
export default connect(mapStateToProps, {prepareDocs,regenCodes,messageShow})(Codes);